
import { axiosApi } from './api';

//
export const EnterpriseBackground = {
    //根据企业名进行搜索
    search: () => {
        return axiosApi("get", "/firm/currentUser")({

        })
    },
    //获取所有用户信息
    projectUserAll: (projectId) => {
        return axiosApi("get", "/user/projectusers")({
            projectId
        })
    },
    
    //企业更新密码
    userpass: (firmId, newPsw, oldPsw) => {
        return axiosApi("put", "/firm/update/psw")({
            firmId,
            newPsw,
            oldPsw
        })
    },
    //更新企业信息
    firmUpdate: (firmId, firmName, firmEmail, firmAddress, operatorName, deptJobName, operatorTel, firmDesc
    ) => {
        return axiosApi("put", "/firm/update/firm")({
            firmId, firmName, firmEmail, firmAddress, operatorName, deptJobName, operatorTel, firmDesc
        })
    },
    //重置用户密码
    UserplayPass: (uid) => {
        return axiosApi("put", "/user/updatedefaultpsw")({
            uid
        })
    },
    //更新用户信息
    defaultUp: (uid, img, realName, tel, jobNumber, deptName, username) => {
        return axiosApi("put", "/user/update")({
            uid, img, realName, tel, jobNumber, deptName, username
        })
    },
    //删除用户信息
    deletUser: (uid) => {
        return axiosApi("delete", "/user/delete")({
            uid
        })
    },
    //批量删除用户信息
    deletUsers: (uids) => {
        return axiosApi("delete", "/user/deletes", false)({ uids })
    },
    //用户注册
    registerUser: (firmId, password, realName, rePsw, tel, deptName, img, jobNumber) => {
        return axiosApi("post", "/user/register")({
            firmId, password, realName, rePsw, tel, deptName, img, jobNumber
        })
    },
    //获取所有部门信息接口
    firmBjnt: (firmId) => {
        return axiosApi("get", "/dept/job/firm")({
            firmId
        })
    },
    //删除企业图
    userPngDetele: (id) => {
        return axiosApi("put", "/firm/imgs/del")({
            id
        })
    },
    userChangeImg: (id) => {
        return axiosApi("put", "/project/img/update")({
            id
        })
    },
}
